// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React, { useState, useEffect, useCallback } from 'react';
import { ContextMenu } from './ContextMenu';
const listeners = new Set();
let currentState = null;
function emit() {
    listeners.forEach((listener) => {
        listener(currentState);
    });
}
export function showContextMenu(props) {
    currentState = props;
    emit();
}
export function hideContextMenu() {
    var _a;
    (_a = currentState.onClose) === null || _a === void 0 ? void 0 : _a.call(currentState);
    currentState = null;
    emit();
}
export function isContextMenuVisible() {
    return currentState !== null;
}
// #endregion Event API
// #region React Host Component
export const ContextMenuHost = () => {
    const [state, setState] = useState(null);
    useEffect(() => {
        const listener = (props) => {
            setState(props);
        };
        listeners.add(listener);
        return () => {
            listeners.delete(listener);
        };
    }, []);
    const handleClose = useCallback(() => {
        hideContextMenu();
    }, []);
    if (state === null) {
        return null;
    }
    return React.createElement(ContextMenu, { items: state.items, position: state.position, onClose: handleClose });
};
// #endregion React Host Component
